import api from "./api";

const key = () => `commercial-${Date.now()}-${Math.random().toString(16).slice(2)}`;
const config = () => ({ headers: { "Idempotency-Key": key() } });

export const commercialSalesService = {
  listAgents() { return api.get("/sales/commercial/agents"); },
  saveAgent(payload) { return api.post("/sales/commercial/agents", payload, config()); },
  listAssignments() { return api.get("/sales/commercial/assignments"); },
  saveAssignment(payload) { return api.post("/sales/commercial/assignments", payload, config()); },
  listCommissionPlans() { return api.get("/sales/commercial/commission-plans"); },
  saveCommissionPlan(payload) { return api.post("/sales/commercial/commission-plans", payload, config()); },
  listApprovals(type) { return api.get("/sales/commercial/approvals", { params: type ? { type } : {} }); },
  decide(orderId, payload) { return api.post(`/sales/commercial/orders/${orderId}/decision`, payload, config()); },
  prepare(orderId, items) { return api.post(`/sales/commercial/orders/${orderId}/prepare`, { items }, config()); },
  acceptQuote(quoteId, items) { return api.post(`/sales/commercial/quotes/${quoteId}/convert-to-order`, { items }, config()); },
  listCommissions(status) { return api.get("/sales/commercial/commissions", { params: status ? { status } : {} }); },
};

export default commercialSalesService;
